<script lang="ts">
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { isLoggedIn } from './utils/login.service.js';
  import { OAuthSession } from './utils/oauth-session.js';

  onMount(() => {
    isLoggedIn.set(false);
    OAuthSession.removeOAuthTokenResponseFromSession();
    navigate('/login');
  });
</script>
